import { t } from '@gem/modules/i18n';
import { logger } from '@gem/modules/logger';

import Tasks from 'APP/Tasks';
import { storage } from 'APP/packages/storage';
import { ISendFeedbackRequest } from 'APP/types/feedback';
import Entities from 'STORE';

// Needs BFF realization
export const sendFeedback = async (data: ISendFeedbackRequest): Promise<void> => {
  try {
    storage.feedback.setStartSkipValue();
    Entities.toast.show(t('feedback_sent'));
  } catch (error) {
    Tasks.app.showAlert(t('common_somethings_wrong_error'));
    storage.feedback.resetSkipValue();
    storage.feedback.setDontShowValue(false);
    logger.get('API').error('calls.sendFeedback', error);
  }
};
